/*
 * GEOV-247: the create-project wizard kept a 24h draft per user in
 * localStorage (`geoverse:createProjectDraft:<userId>`). The wizard is gone
 * — Stage 1 saves to the server — so its drafts are removed on app load.
 */
export const CREATE_PROJECT_DRAFT_PREFIX = "geoverse:createProjectDraft";

export function clearCreateProjectDrafts(storage: Storage = localStorage) {
  try {
    // Collect first: removing while iterating shifts the indexes.
    const keys: string[] = [];

    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key?.startsWith(`${CREATE_PROJECT_DRAFT_PREFIX}:`)) keys.push(key);
    }

    keys.forEach((key) => storage.removeItem(key));
  } catch {
    // Storage can be unavailable (private mode, blocked site data); a stale
    // draft is harmless, so never let this break app start-up.
  }
}
